import { combine, sample } from 'effector';
import { createGetPlayerDetailsQuery } from 'shared/api';
import { createState } from 'shared/lib';
import { authorizedPlayerRoute } from 'shared/routing';

export type PlayerPageTabValues = 'info' | 'transactions';

const getPlayerDetailsQuery = createGetPlayerDetailsQuery();

const $player = getPlayerDetailsQuery.$data;

const $playerName = $player.map((player) => player?.name ?? null);

const $pending = combine(
	{
		player: $player,
		pending: getPlayerDetailsQuery.$pending,
	},
	({ player, pending }) => !player && pending,
);

const currentTabState = createState<PlayerPageTabValues>('info');

sample({
	clock: authorizedPlayerRoute.opened,
	filter: ({ params }) => Number.isFinite(Number(params.id)),
	fn: ({ params }) => Number(params.id),
	target: getPlayerDetailsQuery.start,
});

sample({
	clock: authorizedPlayerRoute.opened,
	fn: ({ query }) => (query.tab === 'transactions' ? 'transactions' : 'info'),
	target: currentTabState.setValue,
});

sample({
	clock: authorizedPlayerRoute.closed,
	target: [getPlayerDetailsQuery.reset, currentTabState.$value.reinit],
});

export const playerPageModel = {
	getPlayerDetailsQuery,
	$player,
	$playerName,
	$pending,
	currentTabState,
};
